module.exports = __webpack_public_path__ + "media/images/icons/search-3a9f9665e5953aec39159ab720ae646c.svg";